module.exports = __webpack_public_path__ + "static/media/tom_chix2_200x200.27c40ec7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/tom_chix2_200x200.jpg
// module id = 339
// module chunks = 0